"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFiocInterstitial = void 0;
const features_1 = require("../../../features");
const useFiocInterstitialBase_hook_1 = require("./useFiocInterstitialBase.hook");
const initializer_1 = require("../../../initializer");
const react_1 = require("react");
const useFiocInterstitial = ({ fiocData }) => {
    const profileRepository = (0, react_1.useRef)(new features_1.ProfileRepository(initializer_1.API));
    return (0, useFiocInterstitialBase_hook_1.useFiocInterstitialBase)({ fiocData, profileRepository: profileRepository.current });
};
exports.useFiocInterstitial = useFiocInterstitial;
//# sourceMappingURL=useFiocInterstitial.hook.js.map